<template>
  <div>
    <b>{{ item.name_prefix }}&nbsp;{{ item.name }}</b>
    <br>
    <span>{{ item.license_plate }}</span>
    <br />
    <strong><span class="text-danger">{{ item.tel }}</span></strong>
  </div>
</template>

<script>
export default {
  props: {
    item: { required: true },
  }
}
</script>